import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import AutTable from '../../blocks/aut-grid-table';
import Form from '../../common/form';
import RTWSummaryItemForm from './rtSummaryItemForm';

import * as data from '../../../utils/data';
import * as models from '../../../utils/models';

class RTWSummaryOverviewForm extends Form {
	state = {
		data: initialData,
		errors: {},
		loading: false,
		progress: 0,
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	schema = {
		weldNumber: Joi.string().min(3).required().label('Weld Number'),
		viResult: Joi.string().min(3).required().label('Visual Inspection Result'),
		lptResult: Joi.string().min(3).required().label('LPT Result'),
		shearWaveResult: Joi.string().min(3).required().label('Shear Wave Result'),
		defectType: Joi.string().min(3).required().label('Defect Type'),
		result: Joi.string().required().label('Result'),
		data: Joi.array()
			.min(1)
			.items(
				Joi.object({
					srNo: Joi.number().positive().required().label('SR No'),
					rtPartNumber: Joi.string().required().label('RT Part Number'),
					artifacts: Joi.string().required().label('Artifacts'),
					discontinuities: Joi.string().required().label('Discontinuities'),
					discontinuitiesLength: Joi.number()
						.required()
						.label('Discontinuities Length (mm)'),
					discontinuitiesType: Joi.string()
						.required()
						.label('Discontinuities Type'),
					defect: Joi.string().required().label('Defect'),
					defectType: Joi.string().required().label('Defect Type'),
					defectLength: Joi.number().required().label('Defect Length (mm)'),
					pipeDiameter: Joi.number()
						.required()
						.label('Diameter of Pipe (inches)'),
					schedule: Joi.string().required().label('Schedule'),
					pipeSpec: Joi.string().required().label('Pipe Specification'),
					drtResult: Joi.string().required().label('DRT Result'),
				})
			)
			.required()
			.label('Scan Details'),
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({ data: initialData });
	};

	onAddItem = (item: models.RTWSummaryItem) => {
		const data: any = { ...this.state.data };
		data.data = [...data.data];
		data.data.push({ ...item, srNo: this.state.data.data.length + 1 });

		this.setState({ data });
	};

	onDeleteItem = (item: models.RTWSummaryItem): void => {
		const data = { ...this.state.data };
		data.data = data.data.filter(
			(i: models.RTWSummaryItem) => i.srNo !== item.srNo
		);

		this.setState({ data });
	};

	render() {
		return (
			<React.Fragment>
				<RTWSummaryItemForm onAdd={this.onAddItem} />

				<div className="divider my-4"></div>

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'weldNumber',
								label: 'Weld Number',
								placeholder: 'Enter Weld Number',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'viResult',
								label: 'Visual Inspection Result',
								placeholder: 'Enter Visual Inspection Result',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'lptResult',
								label: 'LPT Result',
								placeholder: 'LPT Result',
							})}
						</div>
					</div>

					<div className="divider my-4"></div>

					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'shearWaveResult',
								label: 'Shear Wave Result',
								placeholder: 'Enter Shear Wave Result',
							})}
						</div>

						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'defectType',
								label: 'Defect Type',
								placeholder: 'Enter Defect Type',
							})}
						</div>

						<div className="col">
							{this.renderSelect({
								name: 'result',
								label: 'Result',
								placeholder: 'Select Result',
								options: data.getResultOptions(),
							})}
						</div>
					</div>

					<div className="d-flex justify-content-end">
						{this.renderButton('Proceed')}
					</div>
				</form>

				<div className="divider my-4"></div>

				<AutTable
					tableColumns={columns}
					data={this.state.data.data}
					onDeleteItem={this.onDeleteItem}
				/>
			</React.Fragment>
		);
	}
}

const initialData: models.RTWSummaryOverviewData = {
	weldNumber: '',
	viResult: '',
	lptResult: '',
	shearWaveResult: '',
	defectType: '',
	result: '',
	data: [],
};

const columns: models.Column[] = [
	{
		path: 'rtPartNumber',
		label: 'RT Part Number',
	},
	{
		path: 'artifacts',
		label: 'Artifacts',
	},
	{
		path: 'discontinuities',
		label: 'Discontinuities',
	},
	{
		path: 'discontinuitiesLength',
		label: 'Discontinuities Length (mm)',
	},
	{
		path: 'discontinuitiesType',
		label: 'Discontinuities Type',
	},
	{
		path: 'defect',
		label: 'Defect',
	},
	{
		path: 'defectType',
		label: 'Defect Type',
	},
	{
		path: 'defectLength',
		label: 'Defect Length (mm)',
	},
	{
		path: 'pipeDiameter',
		label: 'Diameter of Pipe (inches)',
	},
	{
		path: 'schedule',
		label: 'Schedule',
	},
	{
		path: 'pipeSpec',
		label: 'Pipe Specification',
	},
	{
		path: 'pipeSpec',
		label: 'Pipe Specification',
	},
	{
		path: 'drtResult',
		label: 'DRT Result',
	},
];

export default RTWSummaryOverviewForm;
